import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import ExportSiteListViewModel from '../ViewModels/ExportSiteListViewModel';
import { RadioGroup, Radio } from '@mui/material';


interface IProps {
    dialogOpen: boolean;
    handleClose: () => void;
    exportSiteList: (exportFilters: ExportSiteListViewModel) => void;
}

export default function ExportSitePDFDialog({ dialogOpen, handleClose, exportSiteList }: IProps) {
    const [exportFilters, setExportFilters] = useState<ExportSiteListViewModel>(
        new ExportSiteListViewModel()
    );

    const onCheckBoxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setExportFilters((f) => ({
            ...f,
            [name]: checked,
        }));
    };

    const handleRadio = (name: keyof ExportSiteListViewModel) => (e: React.ChangeEvent<HTMLInputElement>) =>
        setExportFilters(f => ({
            ...f,
            [name]: (e.target as HTMLInputElement).value
        }));

    const resetForm = () => {
        setExportFilters(new ExportSiteListViewModel());
        handleClose();
    };

    const submit = () => {
        exportSiteList(exportFilters);
        resetForm();
    };

    return (
        <Dialog open={dialogOpen} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Site Details Export</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <Box sx={{ border: '1px solid #ccc', borderRadius: 1, p: 2, mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                Report Options
                            </Typography>
                            <RadioGroup
                                row
                                name="type"
                                value={exportFilters.type}
                                onChange={handleRadio('type')}
                            >
                                <FormControlLabel
                                    value="PDF"
                                    control={<Radio size="small" />}
                                    label="PDF"
                                />
                                <FormControlLabel
                                    value="CSV"
                                    control={<Radio size="small" />}
                                    label="CSV"
                                />
                            </RadioGroup>
                            {exportFilters.type === "PDF" &&
                                <>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={exportFilters.addUserComments}
                                                    name="addUserComments"
                                                    onChange={onCheckBoxChange}
                                                />
                                            }
                                            label="Add User comments to Report"
                                        />
                                        {exportFilters.addUserComments &&
                                            <TextField label="Comments" value={exportFilters.userComment} onChange={(e) => setExportFilters({ ...exportFilters, userComment: e.target.value })} />
                                        }
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={exportFilters.displayToScreen}
                                                    name="displayPDFtoScreen"
                                                    onChange={onCheckBoxChange}
                                                />
                                            }
                                            label="Display PDF directly to screen"
                                        />
                                    </FormGroup>

                                    <TextField label="File Name" value={exportFilters.fileName} onChange={(e) => setExportFilters({ ...exportFilters, fileName: e.target.value })} />
                                </>

                            }
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={submit}>Export</Button>
                <Button onClick={resetForm}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}